<template>
  <div>
    <v-container grid-list-xs fluid>
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Company profile & Settings</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-layout wrap justify-center>
          <v-toolbar flat color="white">
            <v-toolbar-title>
              <span style="color:#0cabc2" align="center">Company profile</span>
            </v-toolbar-title>
          </v-toolbar>
          <v-flex xs8>
            <v-text-field v-model="name" label="Company Name" outline></v-text-field>
          </v-flex>

          <v-flex xs8>
            <v-text-field v-model="address" label="Company address" outline></v-text-field>
          </v-flex>
          <v-flex xs8>
            <v-text-field v-model="phone" label="Company Phone" outline></v-text-field>
          </v-flex>
          <v-flex xs8>
            <v-text-field v-model="fax" label="Company fax" outline></v-text-field>
          </v-flex>
        </v-layout>
        <v-divider inset></v-divider>

        <v-layout wrap justify-center>
          <v-flex xs8>
            <v-toolbar flat color="white">
              <v-toolbar-title>
                <span style="color:#0cabc2;text-decoration:underline"  align="center">Tick to use Grade in system</span>
              </v-toolbar-title>
            </v-toolbar>
            <v-checkbox v-model="setting_grade" label="Grade"></v-checkbox>
            <v-text-field
              v-model="new_grade"
              append-icon="add"
              label="add new grade here "
              single-line
              hide-details
              @click:append="add_grade()"
            ></v-text-field>
            <v-data-table
              :items="gradeList"
              disable-initial-sort
              class="elevation-1"
              hide-headers
              hide-actions
              height="100px"
            >
              <template slot="items" slot-scope="props">
                <tr>
                  <td class="text-xs-right">{{ props.item.name }}</td>
                  <td class="text-xs-right">
                    <v-icon medium color="error" @click="delete_grade(props.item.id)">clear</v-icon>
                  </td>
                </tr>
              </template>
            </v-data-table>

            <v-toolbar flat color="white">
              <v-toolbar-title>
                <span style="color:#0cabc2;text-decoration:underline"  align="center">Tick to use Location in system</span>
              </v-toolbar-title>
            </v-toolbar>
            <v-checkbox v-model="setting_location" label="Location"></v-checkbox>
            <v-text-field
              v-model="new_location"
              append-icon="add"
              label="Add new location here"
              single-line
              hide-details
              @click:append="add_location()"
            ></v-text-field>

            <v-data-table
              :items="locationList"
              disable-initial-sort
              class="elevation-1"
              hide-headers
              hide-actions
              height="100px"
            >
              <template slot="items" slot-scope="props">
                <tr>
                  <td class="text-xs-right">{{ props.item.name }}</td>
                  <td class="text-xs-right">
                    <v-icon medium color="error" @click="delete_location(props.item.id)">clear</v-icon>
                  </td>
                </tr>
              </template>
            </v-data-table>

            <v-toolbar flat color="white">
              <v-toolbar-title>
                <span
                  style="color:#0cabc2;text-decoration:underline" 
                  align="center"
                >Set up price when create DO&PO (suggest tick)</span>
              </v-toolbar-title>
            </v-toolbar>
            <v-checkbox v-model="setting_price" label="Price"></v-checkbox>
            <v-toolbar flat color="white">
              <v-toolbar-title>
                <span
                 style="color:#0cabc2;text-decoration:underline" 
                  align="center"
                >View previous stock KG (10 suggested)</span>
              </v-toolbar-title>
            </v-toolbar>
            <v-text-field
              v-model="stocked_day_limit"
              type="number"
              v-on:change="stocked_day_limit = Math.max(Math.min(Math.round(stocked_day_limit), 10), 0)"
              label="Previous Day Stock (0 = ignore this function)"
              box
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-card>
      <!-- <v-card>
        <v-toolbar dark color="primary">
      
          <v-toolbar-title>Settings</v-toolbar-title>
          <v-spacer></v-spacer>
         
        </v-toolbar>
        <v-list three-line subheader>
          <v-subheader>Company Info</v-subheader>
          <v-list-item>
            <v-list-item-content>
              <v-text-field v-model="name" label="Company Name" outlined></v-text-field>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-text-field v-model="address" label="Company Address" outlined></v-text-field>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-text-field v-model="phone" label="Company Phone" outlined></v-text-field>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-text-field v-model="fax" label="Company Fax" outlined></v-text-field>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-list three-line subheader>
          <v-subheader>Main Setting</v-subheader>
          <v-list-item>
            <v-list-item-action>
              <v-checkbox v-model="setting_grade"></v-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Grade</v-list-item-title>
              <v-list-item-subtitle>Using Grade when create DO & PO</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-action>
              <v-checkbox v-model="setting_location"></v-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Location</v-list-item-title>
              <v-list-item-subtitle>Using Location when create DO & PO</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-action>
              <v-checkbox v-model="setting_price"></v-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-text-field
                v-model="limitDay"
                type="number"
                v-on:change="limitDay = Math.max(Math.min(Math.round(limitDay), 10), 1)"
                label="Previous Day Stock"
                box
              ></v-text-field>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-text-field v-model="name" label="Company Name" outlined></v-text-field>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>-->
    </v-container>
    <!-- Snackbar when axios method responsed  (jump out at bottom) -->
    <v-snackbar v-model="snackbar_response" :bottom="true" :multi-line="true" :timeout="1500">
      {{response_detail}}
      <v-btn color="primary" flat @click="snackbar_response = false">Close</v-btn>
    </v-snackbar>

    <!-- Snackbar when axios method error catched  (jump out at top) -->
    <v-snackbar v-model="snackbar_no_connection" :top="true" :timeout="6000">
      No Internet Connection
      <v-btn color="pink" flat @click="snackbar_connection = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import axios from "axios";
import baseUrl from "@/api/baseurl";
import moment from "moment";
import { debounce } from "lodash";

export default {
  data: () => ({
    baseUrl: baseUrl,
    locationList: [],
    gradeList: [],

    new_grade: "",
    new_location: "",

    name: "",
    address: "",
    phone: "",
    fax: "",
    setting_grade: true,
    setting_location: true,
    setting_price: true,
    stocked_day_limit: "",

    snackbar_response: false,
    snackbar_no_connection: false,
    //others
    response: "",
    response_detail: "",
    vege_adding_loading_value: ""
  }),

  created() {
    this.getGrade();
    this.getLocation();
    this.getCompanyInfo();
  },
  mounted() {},

  watch: {
    name(name) {
      localStorage.name = name;
      this.callDebounce();
    },
    address(address) {
      localStorage.address = address;
      this.callDebounce();
    },
    phone(phone) {
      localStorage.phone = phone;
      this.callDebounce();
    },
    fax(fax) {
      localStorage.fax = fax;
      this.callDebounce();
    },
    setting_grade(setting_grade) {
      localStorage.setting_grade = setting_grade;
      this.callDebounce();
    },
    setting_location(setting_location) {
      localStorage.setting_location = setting_location;
      this.callDebounce();
    },
    setting_price(setting_price) {
      localStorage.setting_price = setting_price;
      this.callDebounce();
    },
    stocked_day_limit(stocked_day_limit) {
      localStorage.stocked_day_limit = stocked_day_limit;
      this.callDebounce();
    }
  },
  methods: {
    callDebounce: _.debounce(function() {
      this.update_company_detail();
    }, 500),

    getGrade() {
      const params = new URLSearchParams();
      params.append("get_grade", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/setting.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.gradeList = response.data.data;
          } else if (response.data.error == true) {
            console.log("Grade List Problem" + response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    getLocation() {
      const params = new URLSearchParams();
      params.append("get_location", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/setting.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.locationList = response.data.data;
          } else if (response.data.error == true) {
            console.log("Location List Problem" + response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    add_grade() {
      const params = new URLSearchParams();
      params.append("add_grade", "1");
      params.append("name", this.new_grade);
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/setting.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.snackbar_response = true;
            this.response_detail = response.data.message;
            this.getGrade();
            this.new_grade = "";
          } else if (response.data.error == true) {
            this.snackbar_response = true;
            this.response_detail = response.data.message;
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    add_location() {
      const params = new URLSearchParams();
      params.append("add_location", "1");
      params.append("name", this.new_location);
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/setting.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.snackbar_response = true;
            this.response_detail = response.data.message;
            this.getLocation();
            this.new_location = "";
          } else if (response.data.error == true) {
            this.snackbar_response = true;
            this.response_detail = response.data.message;
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    delete_grade(id) {
      const params = new URLSearchParams();
      params.append("delete_grade", "1");
      params.append("id", id);
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/setting.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.snackbar_response = true;
            this.response_detail = response.data.message;
            this.getGrade();
            this.new_grade = "";
          } else if (response.data.error == true) {
            this.snackbar_response = true;
            this.response_detail = response.data.message;
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    delete_location(id) {
      const params = new URLSearchParams();
      params.append("delete_location", "1");
      params.append("id", id);
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/setting.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.snackbar_response = true;
            this.response_detail = response.data.message;
            this.getLocation();
            this.new_grade = "";
          } else if (response.data.error == true) {
            this.snackbar_response = true;
            this.response_detail = response.data.message;
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    getCompanyInfo() {
      const params = new URLSearchParams();
      params.append("get_company_info", "get_company_info");

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/setting.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.name = response.data.name;
            this.address = response.data.address;
            this.phone = response.data.phone;
            this.fax = response.data.fax;

            if (response.data.setting_grade == "1") {
              this.setting_grade = true;
            } else {
              this.setting_grade = false;
            }
            if (response.data.setting_location == "1") {
              this.setting_location = true;
            } else {
              this.setting_location = false;
            }
            if (response.data.setting_price == "1") {
              this.setting_price = true;
            } else {
              this.setting_price = false;
            }

            this.stocked_day_limit = response.data.stocked_day_limit;
          } else if (response.data.error == true) {
            console.log("gg");
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    update_company_detail() {
      const params = new URLSearchParams();
      params.append("update_company_detail", "update_company_detail");
      params.append("name", this.name);
      params.append("address", this.address);
      params.append("phone", this.phone);
      params.append("fax", this.fax);
      if (this.setting_grade == true) {
        var settingGrade = "1";
      } else {
        settingGrade = "0";
      }
      if (this.setting_location == true) {
        var settingLocation = "1";
      } else {
        settingLocation = "0";
      }

      if (this.setting_price == true) {
        var settingPrice = "1";
      } else {
        settingPrice = "0";
      }
      console.log(settingGrade);
      params.append("setting_grade", settingGrade);
      params.append("setting_location", settingLocation);
      params.append("setting_price", settingPrice);
      params.append("stocked_day_limit", this.stocked_day_limit);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/setting.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.snackbar_response = true;
            this.response_detail = response.data.message;
          } else if (response.data.error == true) {
            console.log("gg");
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    }
  }
};
</script>

